// ** React Imports
import { matchPath } from "react-router-dom";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Text from "components/typography/Text";
import Block from "components/layout/Block";

// ** Utils & Helpers
import generatePath from "utils/generatePath";
import pseudoFormat from "utils/pseudoFormat";

// ** Routes
import subcontainers from "../containers";

// #####################################################

const navigationItems = ({
	isAllowed,
	login,
	userStatistics,
	currentPathname,
	getProfileDetailsMergeFn,
	isPhone = null,
}) => {
	// eslint-disable-next-line react-hooks/rules-of-hooks
	const { t } = useTranslation(["common", "countries", "userProfile"]);

	// #####################################################

	return !isAllowed
		? []
		: subcontainers.map((route) => {
				return {
					key: route.key,
					link: generatePath(route.path, {
						login: login?.toLowerCase(),
					}),
					exact: route.exact,
					onClick: () => {
						const match = matchPath(currentPathname, {
							path: route.path,
							exact: true,
						});
						if (
							match &&
							typeof getProfileDetailsMergeFn === "function"
						) {
							getProfileDetailsMergeFn();
						}
					},
					stat: userStatistics[route.key] || null,
					content: () => {
						const renderAdditional = () => {
							const stat = userStatistics[route.key];

							if (route.key === "userProfile") {
								return null;
							}

							if (stat && typeof stat === "number") {
								return (
									<Text bold ml={1}>
										{pseudoFormat(stat)}
									</Text>
								);
							}

							return null;
						};

						if (
							isPhone &&
							(route.key === "userFriends" ||
								route.key === "userGallery")
						) {
							const stat = userStatistics[route.key] || null;
							return (
								<Block flex column alignCenter>
									<Text>{t(`userProfile:${route.key}`)}</Text>
									<Text bold>{pseudoFormat(stat)}</Text>
								</Block>
							);
						}

						return (
							<>
								{t(`userProfile:${route.key}`)}
								{renderAdditional()}
							</>
						);
					},
				};
		  });
};

export default navigationItems;
